import { zLookup } from '@/utils/zodHelper';
import { z } from 'zod';

export const MachineSchema = z.object({
  id: z.number().optional(),
  name: z.string(),
  unit: zLookup(),
  division: zLookup().optional(),
  is_active: z.boolean().optional(),
  production_phase: zLookup(),
});

export type MachineSchemaType = z.infer<typeof MachineSchema>;
